import React from "react";

const CallSummaryBoxes = ({ summaryData, selectedKey, onSelect }) => {
  if (!summaryData || Object.keys(summaryData).length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        alignItems: "center",
      }}
    >
      {Object.entries(summaryData).map(([key, value]) => {
        const isActive = selectedKey === key;

        return (
          <div
            key={key}
            onClick={() => onSelect?.(key)}
            style={{
              minWidth: "110px",
              padding: "10px 16px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              cursor: "pointer",
              textAlign: "center",
              backgroundColor: isActive ? "#eaf4ff" : "#fff",
              boxShadow: isActive
                ? "0 0 0 2px rgba(10,130,218,0.2)"
                : "none",
              transition: "all 0.2s ease",
            }}
          >
            <div
              style={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#696969",
                marginBottom: "4px",
              }}
            >
              {key.toUpperCase()}
            </div>

            <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#111",
              }}
            >
              {value}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(CallSummaryBoxes);
